import styled from 'styled-components';

export const PopupAddRepairContainer = styled.div`
  pointer-events: all;
  box-sizing: border-box;
  width: 572px;
  padding: 24px;
  background-color: white;
  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);
  border-radius: 12px;
  max-height: 98vh;

  @media (max-width: 768px) {
    width: 98vw;
  }
`;

export const FieldContainer = styled.div`
  margin-bottom: 18px;
  margin-right: 4px;

  > label {
    color: #4d4d4d;
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: bold;
    display: block;
  }

  textarea {
    height: 100px;
    width: 100%;
    resize: none;
    padding: 6px;
    padding-bottom: 0;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 21px;
    border-color: #ddd;
    outline: none;

    &:focus {
      outline: none;
      border-color: #848484;
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const InfosContainer = styled.div`
  overflow: visible;
  max-height: calc(98vh - 48px);
  padding: 6px;
`;

export const HeaderContainer = styled.div`
  > div {
    display: flex;
    justify-content: space-between;
  }
`;

export const BodyContainer = styled.div`
  margin-top: ${({ validWarranty }) => (!validWarranty ? '40px' : '20px')};
  max-height: calc(100vh - 240px);
  overflow-x: visible;
  overflow-y: ${({ validWarranty }) => (!validWarranty ? 'visible' : 'auto')};
`;
